import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { ProfileRole } from '../../store/profile/profileSlice';

const ProfileRoute = ({ component: Component, isSwitch=false, ...props }) => {

  
    return (
		<div>
			<Component {...props} />
		</div>
    );
};

export { ProfileRoute };
